export default __webpack_public_path__ + "static/TC_Step_3-76dc9e0a68c69aa916fe211b6dbe5a35.svg";